function MainBonusBox() {
  return (
    <div className='bonus-box'>
      <img className='icon' src='/icon/ftd_icon.png' alt='Bonus icon' />
      <h2>125% FTD</h2>
      <img className='icon' src='/icon/fs_icon.png' alt='Bonus icon' />
      <h2>+250 FS</h2>
    </div>
  );
}
export default MainBonusBox;